import { apiRequest } from "../util/apiUtils";

export const discountList = async (params) => {
  try {
    const res = await apiRequest("get", `discount/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const discoutAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `discount/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const discountDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `discount/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const discountStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `discount/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
